<!-- I 5 esiti sono pulsanti sempre visibili; un click su quello gia'
     selezionato lo deseleziona (gestito dal genitore in setFinalDecision). -->
<div class="decision-actions-row">
  @for (status of visibleStatuses; track status.id) {
    <button
      mat-stroked-button
      type="button"
      [disabled]="survey?.is_revised"
      class="decision-action-btn"
      [class.decision-action-btn-selected]="selectedStatus?.id === status.id"
      [class.decision-action-btn-recommended]="isRecommended(status.id) && selectedStatus?.id !== status.id"
      [style.--decision-color]="status.bgcolor"
      (click)="onSelectDecision(status.id)"
    >
      <mat-icon>{{ status.icon }}</mat-icon>
      {{ survey?.is_revised ? status.title : status.titleNoRev }}
      @if (isRecommended(status.id)) {
        <span class="decision-recommended-tag">{{ 'components.surveys.survey-dashboard.survey-dashboard.component.rm.recommended' | translate }}</span>
      }
    </button>
  }
</div>
